import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, useLocation, withRouter, Switch } from 'react-router-dom';
import PrivateRoute from './privateroute';
import { Provider } from 'react-redux';
import store from '../store/store';
import FileUpload from '../components/FileUpload';
import Login from '../components/Login';
import Dashboard from '../components/Dashboard'
import FilesList from '../components/FilesList';
import Settings from '../components/Settings/Settings';
import UserTab from '../components/UserTab';
import Logs from '../components/Logs/Logs';
import ResetTempPasswordContainer from '../components/ResetTempPassword';
import FileDetails from '../components/FileDetails';
import ErrorComponent from '../components/Error/Error';
import RegionsListContainer from '../components/RegionList';
import DeviceListContainer from '../components/Devices';
import DeviceDetails from '../components/Devices/DeviceDetails';
import CaseListContainer from '../components/CaseList';
import { RoutesSlugs } from '../constants/definedRoutes/definedRoutes';

/**
* @description function to move the scroll bar to top after each transition
* @param {*}
* @memberof routes
*/
function ResetWindowScroll(props) {
	const { pathname } = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);
	return props.children
}
const ScrollToTop = withRouter(ResetWindowScroll)


const routes = (
	<Provider store={store}>
		<Router>
			<ScrollToTop>
				<Switch>
					<Route exact path={RoutesSlugs.auth.home} component={Login} />
					<Route exact path={RoutesSlugs.auth.login} component={Login} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.dashboard} component={Dashboard} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.assets.upload} component={FileUpload} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.assets.list} component={FilesList} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.assets.details} component={FileDetails} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.regions.list} component={RegionsListContainer} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.systemLogs} component={CaseListContainer} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.settings} component={Settings} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.users.list} component={UserTab} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.devices.list} component={DeviceListContainer} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.devices.details} component={DeviceDetails} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.auditLogs} component={Logs} />
					<PrivateRoute authentication={true} exact path={RoutesSlugs.auth.resetPassword} component={ResetTempPasswordContainer} />
					<Route path="*" component={ErrorComponent} />
				</Switch>
			</ScrollToTop>
		</Router>
	</Provider>
);
export default routes;